// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","title":"模型转换 - Model Flow","parentId":"@@/global-layout","id":"1"},"2":{"path":"/history","title":"历史记录 - ModelFlow","parentId":"@@/global-layout","id":"2"},"3":{"path":"/jobs/:id","title":"任务详情 - ModelFlow","parentId":"@@/global-layout","id":"3"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__index" */'@/pages/index.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__history" */'@/pages/history.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__job" */'@/pages/job.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/app/src/layouts/index.tsx')),
},
  };
}
